import { normalize_text } from './view_case_details_core_helpers';

function primary_runtime(component) {
  return Array.isArray(component.sla_runtimes) ? component.sla_runtimes[0] : null;
}

export const display_sla_badge = (component) => ({
  class: normalize_text(primary_runtime(component)?.tone_class),
  label: normalize_text(primary_runtime(component)?.badge_label || component.case_header?.status_badge),
});

export const display_sla_runtimes = (component) =>
  Array.isArray(component.sla_runtimes) ? component.sla_runtimes : [];
